import { render, staticRenderFns } from "./PrescriptionItemSpecialRX.vue?vue&type=template&id=7264a036&scoped=true"
import script from "./PrescriptionItemSpecialRX.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemSpecialRX.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionItemSpecialRX.vue?vue&type=style&index=0&id=7264a036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264a036",
  null
  
)

export default component.exports